import React from 'react';
import bgImage from '../../assets/About/servicesSection.jpeg';

const values = [
  '24×7 support & maintenance.',
  'Reduce business risks.',
  'Rapid team mobilization.',
  'Get high return on investment (ROI).',
  'Risks and build mitigation plan and dependencies.',
];

const AboutStrengths = () => (
  <div
    className="relative bg-cover bg-center py-20 px-6 overflow-hidden text-white"
    style={{ backgroundImage: `url(${bgImage})` }}
  >
    <div className="absolute inset-0 bg-[#2584C6]/70"></div>

    <div className="relative z-10">
      <div className="text-center mb-12">
        <h3 className="text-white text-lg font-semibold">— Our Strengths —</h3>
        <h2 className="text-3xl md:text-4xl font-bold mt-2">Our Value Adders</h2>
      </div>

      <div className="flex flex-wrap justify-center gap-6 max-w-6xl mx-auto">
        {values.map((value, idx) => (
          <div
            key={idx}
            className="bg-white text-gray-800 shadow-lg rounded-lg p-6 text-center text-sm font-medium w-full sm:w-[300px] md:w-[360px]"
            data-aos="zoom-in"
            data-aos-delay={idx * 100}
          >
            {value}
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default AboutStrengths;
